import { render } from "./PageEmployeeList.vue?vue&type=template&id=4a64ba20"
import script from "./PageEmployeeList.vue?vue&type=script&lang=js"
export * from "./PageEmployeeList.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/meruhensya.com/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__